module.exports = __webpack_public_path__ + "img/ontrack.74518001.jpg";